/**
 * Full-screen ground for the auth pages: the flat jewel-deep of the active
 * colorway (--sidebar-background). The design system forbids gradients; the
 * old random gradient also re-rolled its angle and pattern on every load.
 */
export function AnimatedBackground() {
  return <div className="fixed inset-0 pointer-events-none bg-sidebar" aria-hidden />;
}
